export const GENAI_MIL_MODELS = {
  'gemini-pro': {
    id: 'gemini-pro',
    label: 'Gemini 3.1 Pro for Government',
    vendor: 'Google',
    vendorColor: '#4285F4',
    orModel: 'google/gemini-2.5-pro-preview',
    enabled: true,
    badge: 'IL5',
    description: 'Google\'s most capable model, optimized for government use.',
  },
  'chatgpt': {
    id: 'chatgpt',
    label: 'ChatGPT for Government',
    vendor: 'OpenAI',
    vendorColor: '#10A37F',
    orModel: 'openai/gpt-4.1',
    enabled: true,
    badge: 'IL5',
    description: 'OpenAI ChatGPT, authorized for CUI handling.',
  },
  'grok-gov': {
    id: 'grok-gov',
    label: 'xAI for Government (Grok)',
    vendor: 'xAI',
    vendorColor: '#E8E8E8',
    orModel: 'x-ai/grok-3-beta',
    enabled: true,
    badge: 'IL5',
    description: 'xAI\'s Grok model, authorized for government use.',
  },
  'claude': {
    id: 'claude',
    label: 'Claude (Anthropic)',
    vendor: 'Anthropic',
    vendorColor: '#D97757',
    orModel: null,
    enabled: false,
    badge: 'REMOVED',
    description: 'Removed from platform per DoW directive.',
  },
} as const;

export type GenAIModelId = keyof typeof GENAI_MIL_MODELS;
export const DEFAULT_GENAI_MODEL: GenAIModelId = 'chatgpt';
